export default __webpack_public_path__ + "static/girl-5f0f31e26d5f2388c3735505abed9244.svg";